// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_dc-2";
export var aiChatCartContainerExit = "_dc-4";
export var aiChatContainerLarge = "_dc-0";
export var aiChatContainerSmall = "_dc-1";
export var aiChatIcon = "_dc-6";
export var slideInFromRight = "_dc-3";
export var slideOutToRight = "_dc-5";